import services from '../../../utils/services';
import s from './ServicesMobile.module.scss';
console.log({ s });

const ServicesMobile = () => {
  return (
    <main className={s.wrapper}>
      <section id="services" className={s.content}>
        {services.map((service) => (
          <div className={s.item} key={service.id}>
            <div className={s.title}>{service.title}</div>
            <ul className={s.serviceList}>
              {service.services.map((text, index) => (
                <li className={s.text} key={`${index}_${text}`}>{`- ${text}`}</li>
              ))}
            </ul>
          </div>
        ))}
      </section>
    </main>
  );
};

export default ServicesMobile;
